<template>
  <base-dialog width="800px" :visible.sync="visible" class="subprocess-detail-dialog">
    <template v-slot:header>
      <div class="title">
        <span>详情</span>
      </div>
    </template>
    <div class="detail-list" v-loading="loading">
      <div class="subprocess-detail">
        <div class="status">状态</div>
        <div class="name">名称</div>
        <div class="res-msg">消息</div>
        <div class="start-time">开始时间</div>
        <div class="end-time">结束时间</div>
      </div>
      <div v-for="(item, index) in subprocessDetailList" :key="index" class="subprocess-detail">
        <div class="status">
          <i v-if="item.status === '进行中'" class="el-icon-time icon-status"></i>
          <i v-else-if="item.status === '完成'" class="el-icon-success icon-status"></i>
          <i v-else-if="item.status === '执行失败'" class="el-icon-error icon-status"></i>
          <span class="status-text">{{ item.status }}</span>
        </div>
        <div class="name" v-tip>{{ item.name }}</div>
        <div class="res-msg" v-tip>{{ item.resMsg }}</div>
        <div class="start-time">{{ item.startTime }}</div>
        <div class="end-time">{{ item.endTime }}</div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import { getSubActivityInstList } from "@/api/workflow/processHistory"

export default {
  name: "subprocess-detail-dialog",
  components: { BaseDialog },
  data() {
    return {
      visible: false,
      loading: false,
      subprocessDetailList: []
    }
  },
  methods: {
    open(activity) {
      this.visible = true
      this.loading = true
      getSubActivityInstList(activity.subProcessInsId).then(res => {
        this.subprocessDetailList = res
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subprocess-detail-dialog {
  .detail-list {
    height: 500px;
    .subprocess-detail {
      border-bottom: 1px solid #ddd;
      padding: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      .status {
        display: flex;
        align-items: center;
        width: 80px;
        .status-text {
          font-size: 14px;
          font-weight: 600;
        }
        .icon-status {
          font-size: 20px;
          margin-right: 10px;
        }
        .el-icon-time {
          color: #2195f3;
        }
        .el-icon-success {
          color: #01ca83;
        }
        .el-icon-error {
          color: #ca3820;
        }
      }
      .name {
        width: 100px;
        margin-right: 6px;
      }
      .res-msg {
        flex: 1;
        margin-right: 6px;
      }
      .start-time {
        width: 145px;
      }
      .end-time {
        width: 140px;
      }
    }
  }
  ::v-deep {
    .el-dialog__body {
      margin-bottom: 20px;
    }
  }
}
</style>
